/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface JobPositionFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    name?: boolean;
    leadershipPosition?: boolean;
    positionObjective?: boolean;
    responsibilities?: boolean;
    levelResponsibilityId?: boolean;
    makeDecisions?: boolean;
    hasPersonnelUnderCharge?: boolean;
    numberOfEmployeesDirect?: boolean;
    numberOfEmployeesIndirect?: boolean;
    positionDependPositions?: boolean;
    canControlBudgets?: boolean;
    amount?: boolean;
    informationAdditional?: boolean;
    ageMin?: boolean;
    ageMax?: boolean;
    businessTrips?: boolean;
    professionalGraduateId?: boolean;
    areaOrSpecialty?: boolean;
    specificExpertiseRequired?: boolean;
    language?: boolean;
    technicalTools?: boolean;
    languageOrPrograms?: boolean;
    statusId?: boolean;
    code?: boolean;
    companyId?: boolean;
    departmentId?: boolean;
    areaId?: boolean;
    genreId?: boolean;
    maritalStatusId?: boolean;
    academicLevelId?: boolean;
}

